// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2Prda","upload":"Small_upload__O0gNe","imageWrap":"Small_imageWrap__1Li17","removeBtn":"Small_removeBtn__1fX6j"};